import { Loader, Box } from 'braid-design-system';
import React, { useState } from 'react';

import { ListingStatus } from 'src/generated/graphql';
import type {
  ClientListingForListingsTab,
  ListingProductForListingsTab,
} from 'src/types/graphql-derived';
import {
  getEmailBoostProduct,
  getSearchBoostProduct,
  getIsListingLus,
} from 'src/utils/listingProducts';

import { PostedView } from './components/Action/PostedView';
import { UnpostedView } from './components/Action/UnpostedView';

interface Props {
  listing: ClientListingForListingsTab;
  expireFunction: () => void;
  isProcessing: boolean;
  listingProducts: ListingProductForListingsTab[];
}

const Actions = ({
  listing,
  expireFunction,
  isProcessing,
  listingProducts,
}: Props) => {
  const isActive = listing.status === ListingStatus.Active;
  const [doingRedirect, setDoingRedirect] = useState(false);
  const setLoadingRedirect = () => setDoingRedirect(true);

  if (isProcessing || doingRedirect) {
    return (
      <Box paddingY="medium" display="flex" justifyContent="center">
        <Loader />
      </Box>
    );
  }

  // Draft ads will not have a "productCode"
  if (listing.legacyProductCode && isActive) {
    return (
      <PostedView
        listing={listing}
        isLus={getIsListingLus(listingProducts, listing)}
        searchBoostProduct={getSearchBoostProduct(listingProducts, listing)}
        emailBoostProduct={getEmailBoostProduct(listingProducts, listing)}
        onEditClick={setLoadingRedirect}
        onExpireClick={expireFunction}
        onViewClick={setLoadingRedirect}
      />
    );
  }

  return (
    <UnpostedView listing={listing} setLoadingRedirect={setLoadingRedirect} />
  );
};

export default Actions;
